// extracted by mini-css-extract-plugin
module.exports = {"hintIcon":"Hint_hintIcon__3O7Ke"};